import React, { useState, useEffect, useRef } from 'react';

export default function StatsSection() {
  const [counts, setCounts] = useState({ businesses: 0, orders: 0, uptime: 0, countries: 0 });
  const sectionRef = useRef(null);
  const [hasAnimated, setHasAnimated] = useState(false);

  const stats = [
    { key: 'businesses', label: 'Businesses Served', value: 5000, suffix: '+', icon: '🏢' },
    { key: 'orders', label: 'Orders Processed', value: 100000, suffix: '+', icon: '📦' },
    { key: 'uptime', label: 'Uptime', value: 99.9, suffix: '%', icon: '⚡' },
    { key: 'countries', label: 'Countries', value: 5, suffix: '+', icon: '🌍' }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          stats.forEach(stat => {
            let start = 0;
            const duration = 2000;
            const increment = stat.value / (duration / 16);
            const timer = setInterval(() => {
              start += increment;
              if (start >= stat.value) {
                setCounts(prev => ({ ...prev, [stat.key]: stat.value }));
                clearInterval(timer);
              } else {
                setCounts(prev => ({ ...prev, [stat.key]: Math.floor(start) }));
              }
            }, 16);
          });
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, [hasAnimated]);

  return (
    <section ref={sectionRef} className="py-8 sm:py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1 mb-4 text-xs font-semibold tracking-wide text-blue-600 uppercase bg-blue-50 rounded-full">
            Our Impact
          </div>
          <h3 className="text-2xl sm:text-3xl font-bold text-slate-800 mb-2 px-4">Trusted by Growing Businesses Worldwide</h3>
          <p className="text-slate-500 text-base sm:text-lg px-4">Join thousands of satisfied customers</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 text-center">
          {stats.map((stat, idx) => (
            <div key={idx} className="transform hover:scale-105 transition duration-300">
              <div className="text-4xl sm:text-5xl mb-2 sm:mb-3">{stat.icon}</div>
              <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-800 mb-1">
                {stat.key === 'uptime' ? counts[stat.key]?.toFixed(1) : counts[stat.key]?.toLocaleString()}
                {stat.suffix}
              </div>
              <div className="text-xs sm:text-sm text-slate-500 font-medium px-2">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}